import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ClockIcon } from "assets/images";
import { useCurrentSeason } from "domain/hooks/getCurrentSeasonInfoHook";
import { TimeUtils } from "utils/TimeUtils";

import "./Timer.scss";
import { TimerItem } from "./TimerItem";

let interval: NodeJS.Timer;

export const Timer = () => {
  const { t } = useTranslation();
  const [remainingMs, setRemainingMs] = useState(0);

  const fetchSeasonInfo = useCurrentSeason()

  useEffect(() => {
    if (!fetchSeasonInfo.viewState.currentSeason) {
      return;
    }

    setRemainingMs(
      Math.max(0, TimeUtils.differenceInMilliseconds(+fetchSeasonInfo.viewState.currentSeason.seasonEnd))
    );
  }, [fetchSeasonInfo.viewState.currentSeason]);

  useEffect(() => {
    interval = setInterval(
      () =>
        setRemainingMs((counterTimer) => {
          return Math.max(0, counterTimer - 1000);
        }),
      1000
    );

    return () => {
      clearInterval(interval);
    };
  }, [remainingMs]);

  useEffect(() => {
    if (remainingMs <= 0) {
      fetchSeasonInfo.actions.refresh()
    }
  }, [remainingMs])

  const remainders = TimeUtils.getRemainders(remainingMs);

  return (
    <div className="timer">
      <div className="container">
        <div className="title">
          <img
            className="icon"
            alt="Timer icon"
            src={ClockIcon}
            width={30}
            height={30}
          />
          {t("timer.title")}
        </div>
        <div className="itemContainer">
          {remainders.days > 0 && (
            <>
              <TimerItem
                number={remainders.days}
                numberType={t("resetType.days.short").toUpperCase()}
              />
              <div className="separator">:</div>
            </>
          )}
          <TimerItem
            number={remainders.hours}
            numberType={t("resetType.hours.short").toUpperCase()}
          />
          <div className="separator">:</div>

          <TimerItem
            number={remainders.minutes}
            numberType={t("resetType.minutes.short").toUpperCase()}
          />
          {remainders.days === 0 && (
            <>
              <div className="separator">:</div>
              <TimerItem
                number={remainders.seconds}
                numberType={t("resetType.seconds.short").toUpperCase()}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
